import React from 'react';

const NavTabs = ({ activeTab }) => {
	return (
		<div className="wizard-navigation">
			<ul className="wizard-navigation-nav">
				<li className={"wizard-navigation-item" + (activeTab === 0 ? ' active' : '')}>
					<a className={'wizard-navigation-link'}>
						Account Holder
					</a>
				</li>
				<li className={"wizard-navigation-item" + (activeTab === 1 ? ' active' : '')}>
					<a className={'wizard-navigation-link'}>
						Billing Details
					</a>
				</li>
				<li className={"wizard-navigation-item" + (activeTab === 2 ? ' active' : '')}>
					<a className={'wizard-navigation-link'}>
						Summary
					</a>
				</li>
				<li className={"wizard-navigation-item" + (activeTab === 3 ? ' active' : '')}>
					<a className={'wizard-navigation-link'}>
						Confirmation
					</a>
				</li>
			</ul>
		</div>
	);
};

export default NavTabs;
